import { grayIconFill } from '../../styles/colors';
import { aidaBaseStyles } from '../../styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	anchor: {
		':hover': {
			cursor: 'pointer',
		},
		...aidaBaseStyles.flexHorizontalCenter,
	},
	avatar: {
		height: 35,
		width: 35,
	},
	chevron: {
		margin: '5px 0 0 10px',
	},
	iconSize: {
		height: 20,
		width: 20,
		flexShrink: 0,
	},
	optionContent: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
	},
	optionStyles: {
		color: grayIconFill,
	},
	select: {
		background: 'none',
		border: 'none',
		padding: '20px 0',
	},
	userOptionsContainer: {},
});
